import { type SxProps, type Theme, Typography } from '@mui/material';
import type { CropMonitoring, ResultHybrid } from '/@/types/crop-monitoring';
import { getHybridSeedName } from '/@/utils/crop-monitoring';

/** The FieldView seed of a hybrid, in small text next to its product name (only when it reads
 * differently: see `getHybridSeedName`). */
const HybridSeedName = ({ hybrid, sx }: { hybrid: CropMonitoring | ResultHybrid; sx?: SxProps<Theme> }) => {
    const seed = getHybridSeedName(hybrid);
    if (!seed) return null;
    return (
        <Typography variant='caption' color='text.secondary' component='span' sx={sx}>
            {seed}
        </Typography>
    );
};

export default HybridSeedName;
